import { IconProps } from '@app/components/Atoms/Icon'
import React from 'react'

export const AccessIcon: React.FC<IconProps> = ({
  onClick,
  className,
  active = false,
  ...rest
}) => {
  const primaryInactive = '#0B2B45'
  const primaryActive = '#FFFFFF'
  const accent = '#61C9DC'

  const mainFill = active ? primaryInactive : primaryActive

  return (
    <svg
      {...rest}
      className={className}
      onClick={onClick}
      width="40"
      height="40"
      viewBox="0 0 93 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Scale & center the original artwork */}
      <g transform="translate(15, 15) scale(0.7)">
        <path
          d="M35.7937 84.5467C21.0488 84.5467 9.02856 72.5145 9.02856 57.6953C9.02856 46.1187 16.3476 36.2571 26.6049 32.4786C26.2576 31.9426 25.9371 31.4335 25.5898 30.8707C24.3077 28.8073 23.0789 26.6367 22.0372 24.5732C9.10869 30.0132 0 42.7689 0 57.6953C0 77.4989 16.0537 93.6044 35.7937 93.6044H52.0077C50.1112 90.7638 48.1612 87.6821 46.3181 84.5467H35.7937Z"
          fill={mainFill}
        />
        <path
          d="M41.1364 0C32.6955 0 25.8306 6.88703 25.8306 15.3551C25.8306 17.231 26.5785 19.6696 27.7538 22.3226C28.0744 23.0729 28.4483 23.8232 28.8223 24.5736C29.864 26.6638 31.0928 28.8076 32.3749 30.8711C32.6955 31.407 33.0427 31.943 33.39 32.4789C37.2365 38.5352 41.1364 43.5464 41.1364 43.5464C41.1364 43.5464 45.7575 37.5973 49.9245 30.8443C51.7676 27.8429 53.5306 24.654 54.7594 21.7866C55.8011 19.348 56.4422 17.1238 56.4422 15.3551C56.4422 6.88703 49.5773 0 41.1364 0Z"
          fill={mainFill}
        />
        <path
          d="M68.6226 39.3398C55.427 39.3398 44.7156 50.0858 44.7156 63.3239C44.7156 68.6298 48.5354 76.7228 53.1298 84.5477C54.9729 87.6831 56.9228 90.7648 58.8194 93.6054C64.0014 101.404 68.6226 107.379 68.6226 107.379C68.6226 107.379 73.2437 101.404 78.4258 93.6054C80.3223 90.7648 82.2722 87.6831 84.1154 84.5477C88.7098 76.7228 92.5295 68.6298 92.5295 63.3239C92.5295 50.0858 81.8181 39.3398 68.6226 39.3398Z"
          fill={accent}
        />
      </g>
    </svg>
  )
}

export default AccessIcon
